/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
// countries menu
$('.m-ilink--countries').on('click', function onCountriesBtnClick(e) {
  e.preventDefault();
  $(this)
    .toggleClass('active')
    .next()
    .toggleClass('open');
});

// sub nav menu
const $navLink = $('.m-nav__link');

$navLink.click(function(e) {
  const subMenu = $(this).parent().find('.m-nav__sub');

  if (subMenu.length) {
    e.preventDefault();
    $navLink.removeClass('active');
    $(this).addClass('active');
    subMenu.removeClass('open');
    $('.m-side__nav .m-nav__sub').removeClass('open');
    $(this).parent().find('.m-nav__sub').toggleClass('open');
    $('.m-header__side--backdrop').fadeIn();
  } else {
    const target = $(this).attr('target');
    if (target) {
      e.preventDefault();
      window.open($(this).attr('href'), target);
    }
  }
});

$('.m-close-btn, .main, .m-header__side--backdrop').click(function onCloseBtn() {
  $('.m-nav-sub').removeClass('open');
  $('.m-nav__link').removeClass('active');
  $('.m-header__side--backdrop').fadeOut();
});

$('.m-nav-sub__btn, .m-nav-sub__subitem__btn').click(function onSubNavClick() {
  if ($(this).hasClass('active')) {
    $(this).toggleClass('active');
    $(this)
      .parent().parent().find('.m-nav-sub__sublist')
      .toggleClass('open');
  } else {
    $(this).parent().parent().parent().find('.active').removeClass('active');
    $(this).addClass('active');
    $(this)
      .parent().parent().parent().find('.open')
      .removeClass('open');
    $(this)
      .parent().parent().find('.m-nav-sub__sublist:first')
      .toggleClass('open');
  }
});

const $currentSubList = $('.m-nav-sub__sublist .current').closest('.m-nav-sub__sublist');

$currentSubList
  // open navigation
  .addClass('open')
  // set minus icon
  .prev('.m-nav-sub__label')
  .children('.m-nav-sub__btn')
  .addClass('active');

$currentSubList
  // set minus icon
  .prev('.m-nav-sub__subitem__label')
  .children('.m-nav-sub__subitem__btn')
  .addClass('active');
